import btnClasses from "../../../commons/Button.module.scss";
import Text from "../../../commons/Text";
import Title from "../../../commons/Title";
import classes from "./index.module.scss";
import { v4 as uuid } from "uuid";
import Carousel from "../Carousel";
import RequestDemo from "../../../Button/RequestDemo";

export default function WhatWeDid({ title, text, list }) {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.carousel}>
            <Carousel />
          </div>
          <div className={classes.content}>
            <Title title={title} number={"03"} />
            <Text text={text} className={classes.text} />
            <ul className={classes.list}>
              {list.map((item) => (
                <li className={classes.item} key={uuid()}>
                  {item}
                </li>
              ))}
            </ul>
            <RequestDemo className={btnClasses.button} />
          </div>
        </div>
      </div>
    </section>
  );
}
